import { observer } from 'mobx-react';
import * as React from 'react';
import { createdScope } from '../../services/claim-responsibility/claim-responsibility-filters.util';
import type { ClaimResponsibilityStore } from '../../stores/claim-responsibility/claim-responsibility.store';
import { Notice } from '../base/notice/notice';
import type { ICustomFilter } from '../data-table/components/filters/filters.models';

export interface IResponsibilityScopeNoticeProps {
    store: ClaimResponsibilityStore;
    /** The claims table's applied filters (`presenter.validFilters`). */
    filters: ICustomFilter[];
    className?: string;
}

/**
 * Says when the claims table is limited to the widget's create-date range. That limit travels on the list
 * request (`createdScope`), not as one of the table's own filters, so without this it would be invisible.
 */
export const ResponsibilityScopeNotice: React.FC<IResponsibilityScopeNoticeProps> = observer(({ store, filters, className }) => {
    const scope = createdScope(filters, store.range);
    if (scope.kind === 'applied') {
        return (
            <Notice tone="info" className={className}>
                Showing claims created {store.rangeLabel}, the range chosen in Active Claims By Responsibility.
            </Notice>
        );
    }
    if (scope.kind === 'overridden') {
        return (
            <Notice tone="info" className={className}>
                Your Created filter is used instead of the widget&apos;s range ({store.rangeLabel}), so totals can differ from the
                widget.
            </Notice>
        );
    }
    return null;
});
